import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59b07976"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "base-namespace-form"
}
const _hoisted_2 = { class: "base-namespace-form__group-row" }
const _hoisted_3 = { class: "base-namespace-form__employees-select-group" }
const _hoisted_4 = { class: "base-namespace-form__employees-select-count" }
const _hoisted_5 = { class: "base-namespace-form__employees-select-count" }

import { computed, onBeforeMount, onMounted, PropType, ref } from 'vue';
import { BaseNamespaceFormDataModel, UserModel } from './models';
import { BaseNamespaceFormFields } from './types';
import {
  TirPmInput,
  TirPmIconPicker,
  IconType,
  IconColorType,
  TirDivider,
  SelectedIconModel,
  Tabs,
  Tab,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from 'tir-components';
import { AdapterService } from './adapter';
import { EmployeeMultiselect } from './components';
import { Skeleton } from './components/skeleton';
import { PlusIcon } from 'tir-style-system/icons/outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'base-namespace-form',
  props: {
  /**Данные формы */
  modelValue: {
    type: Object as PropType<BaseNamespaceFormDataModel>,
    default: () => new BaseNamespaceFormDataModel(),
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;

const adapter = new AdapterService();

/**События */

/**Параметры */


/**Табы */
const tabs = ['Администраторы', 'Команда'];

/**Текущий там */
const currentTab = ref<string>(tabs[0]);
/**Список иконок */
const icons = ref<Array<IconType>>();
/**Список цветов */
const colors = ref<Array<IconColorType>>();
/**Список сотрудников */
const employees = ref<Array<UserModel>>();
/**Состояние загрузки */
const isLoading = ref(false);

/**Название рабочей области */
const name = computed({
  get() {
    return props.modelValue.Name;
  },
  set(value) {
    emit(
      'update:modelValue',
      new BaseNamespaceFormDataModel({
        ...props.modelValue,
        Name: value,
      }),
    );
  },
});
/**Выбранная иконка */
const selectedIcon = computed({
  get() {
    return new SelectedIconModel({
      IconId: props.modelValue.IconId,
      ColorId: props.modelValue.IconColorId,
    });
  },
  set(value) {
    emit(
      'update:modelValue',
      new BaseNamespaceFormDataModel({
        ...props.modelValue,
        IconId: value.IconId,
        IconColorId: value.ColorId,
        IconUrl: icons.value?.find((icon) => icon.IconId === value.IconId)?.IconUrl,
        IconColor: colors.value?.find((color) => color.ColorId === value.ColorId)?.Color,
      }),
    );
  },
});
/**Выбранные идентификаторы админов */
const selectedAdminIds = computed({
  get() {
    return props.modelValue.AdminIds;
  },
  set(value) {
    console.log(value);

    emit(
      'update:modelValue',
      new BaseNamespaceFormDataModel({
        ...props.modelValue,
        AdminIds: value,
      }),
    );
  },
});
/**Выбранные идентификаторы команды */
const selectedTeamIds = computed({
  get() {
    return props.modelValue.TeamIds;
  },
  set(value) {
    emit(
      'update:modelValue',
      new BaseNamespaceFormDataModel({
        ...props.modelValue,
        TeamIds: value,
      }),
    );
  },
});

/**Изменение таба */
const changeTab = (tab: string) => {
  currentTab.value = tab;
};
/**Получить иконки */
const getIcons = async () => {
  const resp = await adapter.getIcons();
  if (resp.IsSuccess) icons.value = resp.Value;
};
/**Получить цвета иконок */
const getColors = async () => {
  const resp = await adapter.getColors();
  if (resp.IsSuccess) colors.value = resp.Value;
};
/**Получить список сотрудников */
const getEmployees = async () => {
  const resp = await adapter.getEmployees();
  if (resp.IsSuccess) employees.value = resp.Value;
};
/**Инициализация данных */
const initData = async () => {
  const promises = new Array<Promise<void>>();
  // Получение данных для пикера иконок
  promises.push(getIcons(), getColors());
  promises.push(getEmployees());

  if (promises.length) {
    isLoading.value = true;
    await Promise.all(promises);
    isLoading.value = false;
  }
};

/**До рендера компонента */
onBeforeMount(async () => {
  await initData();
});

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createBlock(_unref(Skeleton), { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(TirPmInput), {
            modelValue: name.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
            class: "base-namespace-form__namespace-name",
            label: "Название рабочей области",
            "is-with-hint": false
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(TirPmIconPicker), {
            modelValue: selectedIcon.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedIcon).value = $event)),
            icons: icons.value,
            colors: colors.value
          }, null, 8, ["modelValue", "icons", "colors"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Tabs), {
            modelValue: currentTab.value,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((currentTab).value = $event)),
              changeTab
            ],
            class: "base-namespace-form__tabs"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Tab), {
                val: tabs[0],
                label: tabs[0],
                currentTab: currentTab.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(selectedAdminIds.value.length), 1)
                ]),
                _: 1
              }, 8, ["val", "label", "currentTab"]),
              _createVNode(_unref(Tab), {
                val: tabs[1],
                label: tabs[1],
                currentTab: currentTab.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(selectedTeamIds.value.length), 1)
                ]),
                _: 1
              }, 8, ["val", "label", "currentTab"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (currentTab.value === tabs[0])
            ? (_openBlock(), _createBlock(_unref(EmployeeMultiselect), {
                key: 0,
                modelValue: selectedAdminIds.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedAdminIds).value = $event)),
                employees: employees.value,
                class: "base-namespace-form__selected-components"
              }, {
                targer: _withCtx(() => [
                  _createVNode(_unref(TirPmButton), {
                    variant: _unref(TirPmButtonVariantEnum).LinkState,
                    size: _unref(TirPmButtonSizeEnum).Middle
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(PlusIcon))
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить администратора ")
                    ]),
                    _: 1
                  }, 8, ["variant", "size"])
                ]),
                _: 1
              }, 8, ["modelValue", "employees"]))
            : (_openBlock(), _createBlock(_unref(EmployeeMultiselect), {
                key: 1,
                modelValue: selectedTeamIds.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedTeamIds).value = $event)),
                employees: employees.value,
                class: "base-namespace-form__selected-components"
              }, {
                targer: _withCtx(() => [
                  _createVNode(_unref(TirPmButton), {
                    variant: _unref(TirPmButtonVariantEnum).LinkState,
                    size: _unref(TirPmButtonSizeEnum).Middle
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(PlusIcon))
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить сотрудника ")
                    ]),
                    _: 1
                  }, 8, ["variant", "size"])
                ]),
                _: 1
              }, 8, ["modelValue", "employees"]))
        ])
      ]))
}
}

})